import {
    useLocation,
} from 'react-router-dom'

import {
    ActionComponentCreateProps,
} from 'app/shared-components/SkyNetDomain/SkyNetDomain.types'
import request from 'app/requests/Lane/Lane.requests'
import AccountLaneForm from '../AccountLaneForm'

const AccountLaneCreate = ({
    onSuccess,
}: ActionComponentCreateProps) => {
    const {
        state,
    } = useLocation()

    return (
        <AccountLaneForm
            data={{
                ...state?.autofill,
            }}
            requestParam={request.createByAccount()}
            onSuccess={onSuccess}
        />
    )
}

export default AccountLaneCreate
